import React from "react";
import { DatePicker } from "../../../../../../../react-core/Datepicker/DatePicker";
import { Lightbox } from "../../../../../../../react-core/Html/Components/Lightbox";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { addDays, addYears } from "../../../../../../../react-core/utils/date";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { VulnerabilityCategory } from "../../../../../../../Wrap/Constants/Enums/Customer/VulnerabilityCategory";
import { VulnerabilityType } from "../../../../../../../Wrap/Constants/Enums/Customer/VulnerabilityType";
import { VulnerabilityDetail } from "../../../../../../../Wrap/Models/Models/Customer/VulnerabilityDetail";
import { VulnerabilitySupportTypeData } from "../../../../../../../Wrap/Models/Models/Customer/VulnerabilitySupportTypeData";
import { VulnerabilityTypeData } from "../../../../../../../Wrap/Models/Models/Customer/VulnerabilityTypeData";
import { ContentDatePicker, ACCEPT_DATE_FORMATS } from "../../../../../../Shared/Entities/Constants/DateConstants";
import { ITableConfig, Table } from "../../../../../../Shared/Table/Table";
import { SectionHeader } from "../../../Common/SharedComponents";
import { ClientRecordAction } from "../../Action/ClientRecordAction";
import {
    VulnerabilityEndReasons,
    VulnerabilitySupportTypeMap,
    VulnerabilityTypeMap,
    VulnerableCategoryArray,
    VulnerableCategoryMap,
} from "../../Resource/Contents";
import { AccountRoleStore } from "../../Store/Variable";
import { AddNewButton } from "../AddNewButton";

interface IVulnerablePersonTableProps {
    customerId: number;
    hasReadWriteAccess: boolean;
}

interface IVulnerablePersonTableState {
    data: Array<VulnerabilityDetail>;
    vulnerabilityTypeOptions: Array<VulnerabilityTypeData>;
    vulnerabilitySupportTypeOptions: Array<VulnerabilitySupportTypeData>;
    isLoading: boolean;
    isEdit: boolean;
    editIndex: number;
    showEndVulnerabilityPopUp: boolean;
    showAddVulnerabilityPopUp: boolean;
    vulnerabilityToEnd: VulnerabilityDetail;
    vulnerabilityToAdd: VulnerabilityDetail;
}

export class VulnerablePersonTable extends FormComponent<IVulnerablePersonTableProps, IVulnerablePersonTableState> {
    constructor(props: any) {
        super(props);
        this.state = {
            data: [],
            vulnerabilityTypeOptions: null,
            vulnerabilitySupportTypeOptions: null,
            isEdit: false,
            editIndex: null,
            isLoading: false,
            showEndVulnerabilityPopUp: false,
            showAddVulnerabilityPopUp: false,
            vulnerabilityToEnd: null,
            vulnerabilityToAdd: {},
        };
    }

    componentDidMount() {
        this.getVulnerabilityData();
    }

    getVulnerabilityData() {
        this.setState({ isLoading: true });
        ClientRecordAction.getCustomerVulnerabilityDetails(this.props.customerId, (val) => {
            this.setState({
                data: val,
                isLoading: false,
            });
        });
    }

    private getVulnerabilityOptions(category: VulnerabilityCategory, type: VulnerabilityType) {
        ClientRecordAction.getVulnerabilityOptions(category, type, (options) => {
            if (options.Types && options.Types.length > 0) {
                this.setState({ vulnerabilityTypeOptions: options.Types });
            }
            if (options.SupportTypes && options.SupportTypes.length > 0) {
                this.setState({ vulnerabilitySupportTypeOptions: options.SupportTypes });
            }
        });
    }

    private getColumnConfig(): ITableConfig[] {
        if (this.state.data && this.state.data[0]) {
            const bool = JsonDateParser.toDateNoOffset(this.state.data[0].EndDate) <= addDays(new Date(), 1);
        }

        return [
            {
                title: "Category 1",
                key: "VulnerabilityCategory",
                render: (data) => {
                    return <span>{VulnerableCategoryMap[data]}</span>;
                },
            },
            {
                title: "Category 2",
                key: "VulnerabilityType",
                render: (data) => {
                    return <span>{VulnerabilityTypeMap[data]}</span>;
                },
            },
            {
                title: "Helping hand",
                key: "VulnerabilitySupportType",
                render: (data) => {
                    return <span>{VulnerabilitySupportTypeMap[data]}</span>;
                },
            },
            {
                title: "Source",
                key: "InformationSource",
            },
            {
                title: "Review date",
                key: "ReviewDate",
                render: (data) => {
                    return <span>{JsonDateParser.getFormatDate(data, "dd/MM/yyyy")}</span>;
                },
            },
            {
                title: "End date",
                key: "EndDate",
                render: (data) => {
                    return <span>{JsonDateParser.getFormatDate(data, "dd/MM/yyyy")}</span>;
                },
            },
            {
                title: "Note",
                key: "Note",
            },
            {
                title: "User ID",
                key: "UserId",
                render: (data) => {
                    return <span>{data}</span>;
                },
            },
            AccountRoleStore.canEditForAdv() &&
                this.props?.hasReadWriteAccess == true && {
                    title: "",
                    render: (ele, row: VulnerabilityDetail, index) => {
                        return (
                            <>
                                <button
                                    className={"edit-circle-icon-button label-sr-only mr-2"}
                                    title="Edit"
                                    onClick={() => {
                                        this.getVulnerabilityOptions(
                                            row?.VulnerabilityCategory,
                                            row?.VulnerabilityType
                                        );
                                        this.setState({
                                            isEdit: true,
                                            showAddVulnerabilityPopUp: true,
                                            editIndex: index,
                                            vulnerabilityToAdd: row,
                                        });
                                    }}
                                    disabled={
                                        row.EndDate != null && JsonDateParser.toDateNoOffset(row.EndDate) <= new Date()
                                    }
                                >
                                    <span className="icon" aria-hidden="true"></span>
                                    <span className="text">Edit</span>
                                </button>
                                <button
                                    className="btn secondary"
                                    disabled={
                                        row.EndDate != null && JsonDateParser.toDateNoOffset(row.EndDate) <= new Date()
                                    }
                                    onClick={() => this.onRemove(index)}
                                >
                                    <span className="text">End vulnerability</span>
                                </button>
                            </>
                        );
                    },
                },
        ];
    }

    private onDataChange(changes) {
        const { vulnerabilityToAdd } = this.state;
        const _data = JSON.parse(JSON.stringify(vulnerabilityToAdd));
        for (const key in changes) {
            _data[key] = changes[key];
        }
        this.setState({ vulnerabilityToAdd: _data });
    }

    private renderLightBox() {
        const {
            vulnerabilityTypeOptions,
            vulnerabilitySupportTypeOptions,
            vulnerabilityToAdd,
            editIndex,
            isEdit,
        } = this.state;
        const types = vulnerabilityTypeOptions != null ? vulnerabilityTypeOptions : [];
        const supportTypes = vulnerabilitySupportTypeOptions != null ? vulnerabilitySupportTypeOptions : [];

        const data = JSON.parse(JSON.stringify(vulnerabilityToAdd));

        const selectedVulnerabilityType = vulnerabilityTypeOptions?.find(
            (x) => x?.VulnerabilityType == data?.VulnerabilityType
        );
        return (
            <>
                <SelectEditor
                    label="VC Category 1"
                    onChange={(v) => {
                        this.onDataChange({
                            VulnerabilityCategory: v,
                            VulnerabilityType: null,
                            VulnerabilitySupportType: null,
                        });
                        if (v == VulnerabilityCategory.NotSpecified) {
                            this.setState({ vulnerabilityTypeOptions: null, vulnerabilitySupportTypeOptions: null });
                        } else {
                            this.getVulnerabilityOptions(v, VulnerabilityType.NotSpecified);
                        }
                    }}
                    options={VulnerableCategoryArray}
                    getText={(v) => VulnerableCategoryMap[v]}
                    placeholder="Please select"
                    selected={data?.VulnerabilityCategory}
                    cssWrapper="control-size-430 mr-4"
                    required="Please select"
                />
                {data?.VulnerabilityCategory && (
                    <SelectEditor
                        label="VC Category 2"
                        onChange={(v) => {
                            this.onDataChange({ VulnerabilityType: v, VulnerabilitySupportType: null });
                            if (v == VulnerabilityType.NotSpecified) {
                                this.setState({ vulnerabilitySupportTypeOptions: null });
                            } else {
                                this.getVulnerabilityOptions(data?.VulnerabilityCategory, v);
                            }
                        }}
                        options={types.map((x) => x.VulnerabilityType)}
                        getText={(v) => types.filter((x) => x.VulnerabilityType == v)[0].LongName}
                        placeholder="Please select"
                        selected={data?.VulnerabilityType}
                        cssWrapper="control-size-430 mr-4"
                        required="Please select"
                    />
                )}
                {data?.VulnerabilityCategory && data?.VulnerabilityType && (
                    <SelectEditor
                        label="Helping hand"
                        onChange={(v) => {
                            this.onDataChange({ VulnerabilitySupportType: v });
                        }}
                        options={supportTypes.map((x) => x.VulnerabilitySupportType)}
                        getText={(v) => supportTypes.filter((x) => x.VulnerabilitySupportType == v)[0].LongName}
                        placeholder="Please select"
                        selected={data?.VulnerabilitySupportType}
                        cssWrapper="control-size-430 mr-4"
                        required="Please select"
                    />
                )}

                {data?.VulnerabilitySupportType && (
                    <>
                        <SelectEditor
                            label="Source"
                            onChange={(v) => {
                                this.onDataChange({ InformationSource: v });
                            }}
                            options={["Declared", "Observed"]}
                            getText={(v) => {
                                return v;
                            }}
                            placeholder="Please select"
                            selected={data?.InformationSource}
                            cssWrapper="control-size-430 mr-4"
                            required="Please select"
                        />

                        <DatePicker
                            label={"Live event date"}
                            selected={JsonDateParser.toDateNoOffset(data?.StartDate)}
                            showYearDropdown={true}
                            onChange={(d) => this.onDataChange({ StartDate: JsonDateParser.toJsonDateNoOffset(d) })}
                            todayButton={ContentDatePicker.Today}
                            isClearable={true}
                            dateFormat={ContentDatePicker.DateFormat}
                            acceptDateFormats={ACCEPT_DATE_FORMATS}
                            formGroupCssWrapper="control-size-430"
                        />
                    </>
                )}

                {data?.VulnerabilitySupportType &&
                    selectedVulnerabilityType &&
                    selectedVulnerabilityType?.IsPermanent == false &&
                    selectedVulnerabilityType?.ReviewAfterMonths == 0 && (
                        <>
                            <DatePicker
                                label={"End date"}
                                selected={JsonDateParser.toDateNoOffset(data?.EndDate)}
                                showYearDropdown={true}
                                onChange={(d) => this.onDataChange({ EndDate: JsonDateParser.toJsonDateNoOffset(d) })}
                                todayButton={ContentDatePicker.Today}
                                isClearable={true}
                                moreThan={{
                                    errorMessage: "End date cannot be eariler than live event date",
                                    value: data?.StartDate
                                        ? JsonDateParser.toDateNoOffset(data?.StartDate)
                                        : addYears(new Date(), -100),
                                }}
                                atLeast={{ value: new Date(), errorMessage: "" }}
                                dateFormat={ContentDatePicker.DateFormat}
                                acceptDateFormats={ACCEPT_DATE_FORMATS}
                                formGroupCssWrapper="control-size-430"
                            />
                        </>
                    )}

                {data?.VulnerabilityCategory &&
                    data?.VulnerabilitySupportType &&
                    data?.VulnerabilityCategory.valueOf() == VulnerabilityCategory.Complex && (
                        <TextBoxEditor
                            label={"Note"}
                            cssWrapper="control-size-430"
                            required={"Please enter"}
                            value={data?.Note}
                            maxLength={500}
                            onChange={(v) => {
                                this.onDataChange({ Note: v });
                            }}
                        />
                    )}
                {this.state.data[editIndex]?.ReviewDate &&
                    JsonDateParser.toDate(this.state.data[editIndex]?.ReviewDate) < new Date() && (
                        <DatePicker
                            label={"Review date"}
                            selected={JsonDateParser.toDateNoOffset(data?.ReviewDate)}
                            showYearDropdown={true}
                            onChange={(d) => this.onDataChange({ ReviewDate: JsonDateParser.toJsonDateNoOffset(d) })}
                            todayButton={ContentDatePicker.Today}
                            isClearable={true}
                            moreThan={{
                                errorMessage: "Review date cannot be eariler than today",
                                value: new Date(),
                            }}
                            dateFormat={ContentDatePicker.DateFormat}
                            acceptDateFormats={ACCEPT_DATE_FORMATS}
                            formGroupCssWrapper="control-size-430"
                        />
                    )}
                <div className="row">
                    <div className="col-auto">
                        <button
                            className="btn secondary"
                            onClick={() => {
                                this.setState({
                                    showAddVulnerabilityPopUp: false,
                                    isEdit: false,
                                    vulnerabilityToAdd: {},
                                });
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                    <div className="col-auto">
                        <button
                            className="btn primary"
                            onClick={() => {
                                if (this.onAdd(isEdit)) {
                                    this.setState({
                                        showAddVulnerabilityPopUp: false,
                                        isEdit: false,
                                        vulnerabilityToAdd: {},
                                    });
                                }
                            }}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </>
        );
    }

    private onAdd(isEdit: boolean) {
        if (this.isValid()) {
            const { data, vulnerabilityToAdd } = this.state;
            if (isEdit == true) {
                const index = data.findIndex((x) => x.VulnerabilityId == vulnerabilityToAdd.VulnerabilityId);
                data[index] = vulnerabilityToAdd;
            } else {
                data.push(vulnerabilityToAdd);
            }
            this.saveData(data);
            return true;
        }
        return false;
    }

    private onRemove(index) {
        const { data } = this.state;
        this.setState({ vulnerabilityToEnd: data[index], showEndVulnerabilityPopUp: true });
        return true;
    }

    onClickEndVulnerability() {
        if (this.isValid()) {
            const { data, vulnerabilityToEnd } = this.state;
            vulnerabilityToEnd.EndDate = JsonDateParser.toJsonDateNoOffset(new Date());
            const updatedData = data.filter((x) => x.VulnerabilityId != vulnerabilityToEnd.VulnerabilityId);
            updatedData.push(vulnerabilityToEnd);
            this.saveData(updatedData);
        }
    }

    onClickAdd() {
        this.setState({ showAddVulnerabilityPopUp: true });
    }

    saveData(data) {
        ClientRecordAction.saveVulnerabilityDetail(this.props.customerId, data, () => {
            this.getVulnerabilityData();
        });
    }

    render() {
        const {
            data,
            isLoading,
            showEndVulnerabilityPopUp,
            showAddVulnerabilityPopUp,
            vulnerabilityToEnd,
        } = this.state;
        if (isLoading) {
            return <PartLoading isLoading={true} />;
        }
        const activeVulernabilities = data.filter(
            (x) => x.EndDate == null || x.EndDate > JsonDateParser.toJsonDateNoOffset(new Date())
        );
        return (
            <>
                <div className="flex-space">
                    {SectionHeader("Vulnerable details")}

                    {AccountRoleStore.canEditForAdv() && this.props.hasReadWriteAccess == true && (
                        <div className="mb-20">
                            <AddNewButton
                                name="Add new"
                                onClick={() => this.onClickAdd()}
                                isReview={activeVulernabilities.length == 10}
                            />
                        </div>
                    )}
                </div>
                <Table data={data} col={this.getColumnConfig()} showEmptyMsg={true} />
                {showEndVulnerabilityPopUp && (
                    <Lightbox
                        cssWrapper="is-default-lightbox"
                        onClose={() => this.setState({ showEndVulnerabilityPopUp: false })}
                        show={showEndVulnerabilityPopUp}
                        title={"End vulnerability"}
                    >
                        <SelectEditor
                            label="End reason"
                            onChange={(v) => {
                                const data = vulnerabilityToEnd;
                                data.EndReason = v;
                                this.setState({ vulnerabilityToEnd: data });
                            }}
                            options={VulnerabilityEndReasons}
                            getText={(v) => {
                                return v;
                            }}
                            placeholder="Please select"
                            selected={vulnerabilityToEnd?.EndReason}
                            cssWrapper="control-size-430 mr-4"
                            required="Please select"
                        />
                        <div className="row">
                            <div className="col-auto">
                                <button
                                    className="btn secondary"
                                    onClick={() => {
                                        this.setState({ showEndVulnerabilityPopUp: false });
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                            <div className="col-auto">
                                <button
                                    className="btn primary"
                                    onClick={() => {
                                        this.setState({ showEndVulnerabilityPopUp: false });
                                        this.onClickEndVulnerability();
                                    }}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </Lightbox>
                )}
                {showAddVulnerabilityPopUp && (
                    <Lightbox
                        cssWrapper="is-default-lightbox"
                        onClose={() => this.setState({ showAddVulnerabilityPopUp: false })}
                        show={showAddVulnerabilityPopUp}
                        title={"Add vulnerability"}
                    >
                        {this.renderLightBox()}
                    </Lightbox>
                )}
            </>
        );
    }
}
